import { useState } from 'react'
import { useAppsService } from '../_services/AppsService'

interface ArcRequestParams {
  application: any
  selectedArcRoles: any
}

interface UseArcRequestReturn {
  handleSilentArcRequest: (params: ArcRequestParams) => Promise<void>
  isArcRoleLoading: boolean
}

/**
 * Custom hook for handling silent ARC (Access Request and Control) requests
 * @returns Object containing handleSilentArcRequest function and loading state
 */
export const useArcRequest = (): UseArcRequestReturn => {
  const { sendArcRequest } = useAppsService()
  const [isArcRoleLoading, setIsArcRoleLoading] = useState(false)

  const handleSilentArcRequest = async ({
    application,
    selectedArcRoles
  }: ArcRequestParams): Promise<void> => {
    setIsArcRoleLoading(true)
    try {
      const response = await sendArcRequest({
        application,
        selectedArcRoles,
        appAccess: selectedArcRoles.arc || application.arc
      })

      if (response && response.status === 'Success') {
        application.arc.isInProcess = true
      }
    } catch (error) {
      console.error('Error in silent ARC request:', error)
    } finally {
      setIsArcRoleLoading(false)
    }
  }

  return {
    handleSilentArcRequest,
    isArcRoleLoading
  }
}
